import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FormPage from "./Components/FormPage";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import './App.css';
import './styles/form.css';
import DeletePage from "./Components/DeletePage";
import NotFoundPage from "./Components/404";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<FormPage />} />
          <Route path="/delete/:id" element={<DeletePage />} />
          <Route path="*" element={<NotFoundPage/>} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
